import React from "react"
import { Box, Flex, Heading, AspectRatio } from "@chakra-ui/react"
import ResolvedContent from "@app/components/ResolvedContent"
import VideoResponsive from "@app/components/VideoResponsive"
import ResolvedImageResponsive from "@app/components/ResolvedImageResponsive"
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination } from "swiper"
import "swiper/css/pagination"

type Props = {
  productHowToUse: GatsbyTypes.SanityProduct["howToUse"]
}

const ProductTabHowToUse: React.FC<Props> = ({ productHowToUse }) => {
  return (
    <Flex gap={{ base: 0, sm: "16px", lg: "40px" }} flexDir={{ base: "column", lg: "row" }}>
      <Box p={{ base: "16px", lg: "32px" }} pr={{ base: "16px", lg: 0 }} w={{ base: "100%", lg: "45%" }}>
        <Heading fontWeight={700}>{productHowToUse?.heading}</Heading>
        <ResolvedContent
          content={productHowToUse?.content}
          sx={{
            ".content-list": {
              ml: 0,
              listStylePosition: "inside",
              ol: {
                li: {
                  mb: "8px",
                  pl: "16px",
                  textIndent: "-16px",
                },
              },
              a: {
                textDecoration: "underline",
                cursor: "pointer",
              },
            },
            p: {
              fontFamily: "Larsseit",
            },
          }}
        />
      </Box>
      <Box w={{ base: "100%", lg: "55%" }} display={{ base: "none", xs: "block" }}>
        {productHowToUse?.media && productHowToUse?.media?.length === 1 ? (
          <AspectRatio ratio={1.4}>
            {productHowToUse?.media?.[0].type === "video" ? (
              <VideoResponsive video={productHowToUse?.media?.[0].video} />
            ) : (
              <ResolvedImageResponsive image={productHowToUse?.media?.[0]?.image} />
            )}
          </AspectRatio>
        ) : (
          <Flex flexDir="row" gap="24px" w="100%">
            {productHowToUse?.media?.map(media => (
              <AspectRatio key={media._key} ratio={0.68} w="100%">
                {media.type === "video" ? (
                  <VideoResponsive video={media?.video} />
                ) : (
                  <ResolvedImageResponsive image={media?.image} w="100%" />
                )}
              </AspectRatio>
            ))}
          </Flex>
        )}
      </Box>
      {/* MOBILE IMAGE SWIPER */}
      <Box
        display={{ base: "block", xs: "none" }}
        sx={{
          ".swiper-pagination-bullets": {
            position: "static",
            my: "12px",
          },
          ".swiper-pagination-bullet": {
            background: "primary.navy",
          },
        }}
      >
        <Swiper slidesPerView={1} modules={[Pagination]} pagination={{ type: "bullets" }}>
          {productHowToUse?.media && productHowToUse?.media?.length === 1 ? (
            <AspectRatio ratio={1.4}>
              {productHowToUse?.media?.[0].type === "video" ? (
                <VideoResponsive video={productHowToUse?.media?.[0].video} />
              ) : (
                <ResolvedImageResponsive image={productHowToUse?.media?.[0]?.image} />
              )}
            </AspectRatio>
          ) : (
            <Flex flexDir="row" gap="24px" w="100%">
              {productHowToUse?.media?.map(media => (
                <SwiperSlide key={media._key}>
                  <AspectRatio ratio={0.68} w="100%">
                    {media.type === "video" ? (
                      <VideoResponsive video={media?.video} />
                    ) : (
                      <ResolvedImageResponsive image={media?.image} w="100%" />
                    )}
                  </AspectRatio>
                </SwiperSlide>
              ))}
            </Flex>
          )}
        </Swiper>
      </Box>
    </Flex>
  )
}

export default React.memo(ProductTabHowToUse)
